import type { ResourceName } from '@root/@types/types';

export const isEndorsement = (resourceName?: ResourceName) => resourceName?.startsWith('submissions#');
